export default {
    options: {
        classes: {
            answerActive: ['max-h-screen', 'opacity-100'],
            answerInactive: ['max-h-0', 'opacity-0'],
            questionActive: 'pb-8',
            iconActive: 'rotate-180'
        }
    },

    init: function() {
        const self = this;
        const faqHeaders = document.querySelectorAll('[data-faq="header"]');
        
        self.initEvents(faqHeaders);        
    },

    initEvents: function(elements) {
        const self = this;
        elements.forEach(element => {
            element.addEventListener('click', function(e) {
                const icon = element.querySelector('button');
                element.classList.toggle(self.options.classes.questionActive);
                icon.classList.toggle(self.options.classes.iconActive);
                self.options.classes.answerActive.forEach(cl => {
                    element.nextElementSibling.classList.toggle(cl);
                })
                self.options.classes.answerInactive.forEach(cl => {
                    element.nextElementSibling.classList.toggle(cl);
                })
            });
        });
    }
}